'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const DirectoryFileTypeChangeSet = styled.table`
  /* width: 100%; */
  border-collapse: collapse;
  border-spacing: 0;
  /* margin-top: 1rem; */
  margin-left: 20px;
  margin-bottom: 20px;
  font-size: 0.875rem;

  td,
  th {
    &.number {
      text-align: right;
    }
  }

  th {
    text-align: left;
    padding: 0.5rem;
    border-bottom: 1px solid ${colors.secondary.lightGray3};
  }

  td {
    text-transform: capitalize;
    padding: 0.5rem;
    border-bottom: 1px solid ${colors.secondary.lightGray3};
  }

  tr:last-child td {
    border-bottom: none;
    padding-bottom: 0px;
  }
`;
